"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var advertisement_service_1 = require("./../../../Services/advertisement.service");
var router_1 = require("@angular/router");
var dialog_login_component_1 = require("./../../../Dialogs/dialog.login/dialog.login.component");
var user_service_1 = require("./../../../Services/user.service");
var service_service_1 = require("./../../../Services/service.service");
var common_1 = require("@angular/common");
var forms_1 = require("@angular/forms");
var LoginComponent = /** @class */ (function (_super) {
    __extends(LoginComponent, _super);
    function LoginComponent(fb, service, _location, userService, route, advService) {
        var _this = _super.call(this, fb, undefined, null, service) || this;
        _this.service = service;
        _this._location = _location;
        _this.userService = userService;
        _this.route = route;
        _this.advService = advService;
        _this.view = 0;
        _this.loading = false;
        return _this;
    }
    Object.defineProperty(LoginComponent.prototype, "passwordInput", {
        get: function () { return this.loginForm.get('password'); },
        enumerable: true,
        configurable: true
    });
    LoginComponent.prototype.changeView = function (view) {
        this.view = view;
    };
    LoginComponent.prototype.locationBack = function () {
        this._location.back();
    };
    LoginComponent.prototype.ngOnInit = function () {
        if (this.userService.isAuthenticated()) {
            this.service.route.navigate(["/account/"]);
        }
    };
    LoginComponent.prototype.onSubmit = function () {
        var _this = this;
        this.validateAllFormFields(this.loginForm);
        if (!this.loginForm.invalid) {
            if (!this.isCaptchaOk()) {
                this.service.showError("Please confirm the captcha");
            }
            else {
                if (this.userService.isAuthenticated()) {
                    return;
                }
                else {
                    var email = this.loginForm.controls["email"].value;
                    var password = this.loginForm.controls["password"].value;
                    this.loading = true;
                    this.userService.login(email, password, this.loginForm.controls["rememberme"].value, undefined)
                        .then(function (r) {
                        _this.loading = false;
                        // if (this.route.url == "/register") {
                        //   if (url) this.route.navigate(["main"]);
                        // } else {
                        //   if (url) this.route.navigate([url]);
                        // }
                        _this.advService.searchDataUserAdv.currentSearchRule.userId = _this.userService.getUserId();
                        _this.advService.searchActionForUser();
                        _this.route.navigate([""]);
                    })
                        .catch(function (e) {
                        _this.loading = false;
                        _this.service.showError(e);
                    });
                }
                ;
            }
        }
    };
    return LoginComponent;
}(dialog_login_component_1.DialogLoginComponent));
exports.LoginComponent = LoginComponent;
var LoginView;
(function (LoginView) {
    LoginView[LoginView["LoginRegister"] = 0] = "LoginRegister";
    LoginView[LoginView["Login"] = 0] = "Login";
})(LoginView || (LoginView = {}));
